export default __webpack_public_path__ + "assets/b8b15cdf-85d1-4120-8daa-48863d803939-thai.woff2";